import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AdminFilterBar = ({ options = [], value, onChange, ariaLabel = 'Filtreler', className = '' }) => {
  if (!options.length) {
    return null;
  }

  return (
    <div className={['admin-filter-bar', 'admin-segmented-control', className].filter(Boolean).join(' ')} role="group" aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`admin-segment-button admin-filter-button ${value === option.value ? 'active' : ''}`}
          onClick={() => onChange(option.value)}
        >
          {option.icon ? <FontAwesomeIcon icon={option.icon} /> : null}
          <span>{option.label}</span>
          {typeof option.count === 'number' ? <span className="admin-filter-count">{option.count}</span> : null}
        </button>
      ))}
    </div>
  );
};

export default AdminFilterBar;
